import { useState, useEffect } from 'react';
import { authService } from '../services/auth';

export const useAuth = () => {
  const [user, setUser] = useState<any>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Vérifier si l'utilisateur est déjà connecté
    if (authService.isAuthenticated()) {
      console.log('useAuth - Token found, fetching profile...');
      authService.getProfile()
        .then((profileData) => {
          console.log('useAuth - Profile data received:', profileData);
          setUser(profileData);
        })
        .catch((error) => {
          console.error('useAuth - Error fetching profile:', error);
          authService.logout();
        })
        .finally(() => setIsLoading(false));
    } else {
      console.log('useAuth - No token found');
      setIsLoading(false);
    }
  }, []);

  const login = async (email: string, password: string) => {
    try {
      const authResponse = await authService.login(email, password);
      setUser(authResponse.user);
      return authResponse;
    } catch (error) {
      throw error;
    }
  };

  const logout = () => {
    authService.logout();
    setUser(null);
  };

  const updateProfile = async (profileData: any) => {
    try {
      const updatedUser = await authService.updateProfile(profileData);
      setUser(updatedUser);
      return updatedUser;
    } catch (error) {
      throw error;
    }
  };

  const changePassword = async (currentPassword: string, newPassword: string) => {
    try {
      await authService.changePassword(currentPassword, newPassword);
    } catch (error) {
      throw error;
    }
  };

  return {
    user,
    isLoading,
    login,
    logout,
    updateProfile,
    changePassword,
    isAuthenticated: !!user,
  };
};
